import { SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { AntragsContent } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/AntragsContent';
import { useSheetContext } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/SheetContext';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function AntragsSheetContent({
  antrag,
}: {
  antrag: SchichttauschAntrag;
}) {
  const { ctx } = useSheetContext();
  const { t } = useTranslation();

  return (
    <SheetContent
      removeCloseIcon
      className="p-0 flex flex-col gap-6 sm:w-[712px] sm:max-w-[712px]">
      <SheetHeader className="px-4 py-2 bg-neutrals-200 h-[52px] flex justify-center">
        <div className="flex flex-row gap-2 items-center">
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="text-primary-blue-600 size-5 cursor-pointer"
            onClick={() => ctx.setOpen(false)}
          />
          <SheetTitle className="text-neutrals-900 text-sm font-semibold">
            {t(
              'domain.navigation.benachrichtigungen.schichttauschAntraege.dialog.title',
            )}
          </SheetTitle>
        </div>
      </SheetHeader>
      <AntragsContent antrag={antrag} />
    </SheetContent>
  );
}
